import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Alert,
} from "@mui/material";
import { verifyEmail } from "../api/authApi";

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        const data = await verifyEmail(token);
        if (isMounted) {
          setStatus("success");
          setMessage(data.message);
        }
      } catch (err) {
        if (isMounted) {
          setStatus("error");
          setMessage(
            err?.response?.data?.message ||
              "Unable to verify email. The link may be invalid or expired."
          );
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(135deg, #eef6ff 0%, #f5fbfa 50%, #ffffff 100%)",
        px: 1,
      }}
    >
      <Paper
        elevation={8}
        sx={{ width: "100%", maxWidth: 380, p: 4, borderRadius: 3, textAlign: "center" }}
      >
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Email Verification
        </Typography>

        {status === "verifying" && (
          <Box sx={{ py: 2 }}>
            <CircularProgress size={28} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Verifying your email...
            </Typography>
          </Box>
        )}

        {status === "success" && (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
            <Link to="/">Go to Sign In</Link>
          </>
        )}

        {status === "error" && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>
              {message}
            </Alert>
            <Link to="/">Back to Sign In</Link>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default VerifyEmail;